import {
  Divider,
  Stack,
  Tab,
  TabList,
  TabProps,
  Tabs as ChakraTabs,
  useMediaQuery,
} from '@chakra-ui/react';

type HeaderList = {
  name: string;
};

interface ChakraTabsProps extends TabProps {
  tablist: HeaderList[];
  variant?:
    | 'line'
    | 'enclosed'
    | 'enclosed-colored'
    | 'soft-rounded'
    | 'solid-rounded'
    | 'unstyled';
}

export function Tabs({
  tablist,
  variant = 'unstyled',
  children,
  ...props
}: ChakraTabsProps) {
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  return (
    <ChakraTabs variant={variant}>
      <Stack pb={4}>
        <Divider borderWidth="1px" borderColor="gray.33" />
      </Stack>
      <TabList overflowX={isMobile ? 'scroll' : 'auto'} p={2}>
        {tablist.map((item, index) => (
          <Tab
            key={index}
            outlineColor="gray.75"
            borderRadius="md"
            _selected={{ color: 'blue', bg: 'blue.100', outlineColor: 'blue' }}
            whiteSpace="nowrap"
            mr={8}
          >
            {item.name}
          </Tab>
        ))}
      </TabList>
      <Stack pt={4}>
        <Divider borderWidth="1px" borderColor="gray.33" />
      </Stack>
      {children}
    </ChakraTabs>
  );
}

export default Tabs;
